import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, shadowUp } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts } = theme;

export const errorBoundary = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      ${shadowUp};
    `,
  )};
`;

export const heading = css`
  margin: 60px 10px;
  font-weight: 600;
  text-align: center;
  font-family: ${fonts.PRIMARY_REGULAR.family};
  ${theme.responsiveText.HEADING.XL}
`;
